import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionSummary,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Stack,
  Typography
} from '@mui/material';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProgressBar from 'src/components/common/ProgressBar';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { AppState } from 'src/store';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import { UI_TIME_ZONE } from 'src/constants/formats';
import {
  ISQChecklistAfterSiteQualification,
  ISQChecklistDetails,
  ISQChecklistDuringSiteQualification,
  ISQChecklistPriorToVisit,
  SqChecklistPostAfterSiteQualification,
  SqChecklistPostDuringSiteQualification,
  SqChecklistPostPriorDetails
} from 'src/types/SQChecklist';
import IconButton from '@mui/material/IconButton';
import { formatInput } from 'src/util/STR';
import { updateUserAccess } from 'src/util/util';
import SiteInformation from '../steps/SiteInformation';
import { useSiteContactInfo } from '../steps/useSitecontactinfo';
import AfterSiteQualificationVisit from './AfterSiteQualificationVisit';
import DuringSiteQulificationVisit from './DuringSiteQulificationVisit';
import PriorToVisit from './PriorToVisit';
import SQChecklist from './SQChecklist';
import SupportDocuments from './SupportDocuments';
import './sqChecklist.scss';
import { useSqChecklist } from './useSqChecklist';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import moment from 'moment';
import { useCalendarEventByVisitType } from 'src/util/useCalendarEventByVisitType';
import { SERVER_DATE_FORMAT } from 'src/constants/formats';
import { showLoader, hideLoader } from 'src/store/Loader';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useMonitoringVisitLog } from '../studyLogs/MonitoringVisitLogs/useMonitoringVisitLog';
import { archLevel } from 'src/data/config';
import { PopupComponent } from 'src/components/common/PopupComponent';
import Loader from 'src/components/common/Loader';
import { setChckListCMPArr } from 'src/store/sqCheckList';
import staticData from '../../../resources/static.json';
import { DynamicIcon } from '@pihealth/common-ui-library';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';

const SQChecklistPage: React.FunctionComponent<any> = () => {
  const { setTabVal, tabVal, tabsData } = useTab();
  const fromNavigationPathName: any = useAppSelector(state => {
    return state.navigationPath.navigationPathName;
  });

  const [checkedInStartDate, setCheckedInStartDate] = useState<any>(null);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const { selectedAppSection } = useSelectedAppInfo();
  const currentAppName = archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP;
  const currentTabinfo: any = tabsData.filter((item: any) => item.index === tabVal);
  const [sitestudySiteInfo, setSitestudySiteInfo] = useState({});
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const selectedRowData: any = useAppSelector(state => state.sqCheckList.selectedRowData);
  const [isPublish, setIsPublish] = useState(false);
  const [printEnable, setPrintEnable] = useState(false);
  const { user } = useUser();
  const { sqcDataUpdateSuccessMsg, unSavedWarning } = useFieldTranslation();
  const { checkPermission } = usePermissionWrapper();
  const [openAlertPopup, setOpenAlertPopup] = useState(false);
  const [isNavigateToPannel, setIsNavigateToPannel] = useState(true);
  const [teamMembers, setTeamMbers] = useState([]);
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const [updateKey, setUpdateKey] = useState(false);
  const [newPilupdateKey, setnPilupdateKey] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [sqChecklistPILFormData, setSqChecklistPILFormData] = useState<Partial<ISQChecklistDetails>>({});
  const [uploadDocuments, setUploadDocuments] = useState([]);
  const [siteInfoData, setSiteInfoData] = React.useState<any>({});
  const [currentPannel, setCurrentPannel] = useState('');
  const publishChecklistPermission = checkPermission('publish_sq_checklist_etmf');
  const { getMonitoringEventData } = useCalendarEventByVisitType('Site Qualification Visit');

  const {
    siteStudyPersonnelQueryData,
    getSiteStudyPersonnelQueryData,
    siteStudyPersonnelQueryDataIsSuccess,
    siteStudyPersonnelQueryDataLoading,
    siteTsdaStudyPersonnelQueryData,
    siteTsdaStudyPersonnelQueryDataIsSuccess,
    siteTsdaStudyPersonnelQueryDataLoading
  } = useSiteContactInfo();

  const { monitoringVisitIsError, monitoringVisitIsLoading, monitoringVisitIsSuccess, getAllMonitoringVisits } =
    useMonitoringVisitLog();

  const {
    sqChecklistData,
    getsqChecklistError,
    getChecklistData,
    createSqChecklist,
    updateSqChecklist,
    sqChecklistPILData,
    getSqChecklistPILLoading,
    getSqChecklistPILQueryData,
    createSqChecklistPIL,
    updateSqChecklistPIL,
    getsqChecklistIsSuccess,
    getsqChecklistIsError,
    getsqChecklistPILIsSuccess,
    getSqChecklistPILIsError,
    publishSQChecklistEtmf,
    publishSQChecklistSuccess
  } = useSqChecklist();

  const isUpdatePublish = sqChecklistData?.sq_checklist_publish_version ? true : false;

  const mockEmptySQCheckListData = {
    site_visit_date: '',
    site_personnel_present: '',
    site_speciality: '',
    site_experience_trials: '',
    site_trials_completed: 0,
    site_trials_ongoing: 0,
    site_competitive_trials_on: true,
    site_positive_attributes: '',
    site_negative_attributes: '',
    site_requalification_visit: '',
    site_qualification_past_year: '',
    site_qualification_waived: '',
    site_not_suitable: '',
    site_smo_recommended: '',
    site_debarred: '',
    site_debarred_comment: '',
    site_483: '',
    site_483_comment: '',
    site_qualification_comments: '',
    created_by: user,
    site_id: selectedSite,
    study_id: studyId
  };

  const mockEmptySQCheckPILData = {
    sq_visit_date: '',
    sq_reg_meeting_mil_track: false,
    sq_reg_meeting_mil_track_comm: '',
    sq_protocol_review_mil_track: false,
    sq_protocol_review_mil_track_comm: '',
    sq_contract_tim_mil_track: false,
    sq_contract_tim_mil_track_comm: '',
    sq_contract_review_name: false,
    sq_contract_review_name_comm: '',
    sq_current_study_org: false,
    sq_current_study_org_comm: '',
    sq_trial_list: false,
    sq_trial_list_comm: '',
    sq_publication_list: false,
    sq_publication_list_comm: '',
    sq_license_certification: false,
    sq_license_certification_comm: '',
    sq_sample_source_doc: false,
    sq_sample_source_doc_comm: '',
    sq_estimate_subjects: false,
    sq_estimate_subjects_comm: '',
    sq_recruitment_strategy: false,
    sq_recruitment_strategy_comm: '',
    sq_exam_room: false,
    sq_lab_area: false,
    sq_special_testing: false,
    sq_pharmacy: false,
    sq_hospital_unit: false,
    sq_work_area: false,
    sq_storage_area_ip: false,
    sq_storage_area_supplies: false,
    sq_sponsor_tour_comm: '',
    sq_discuss_protocol_rev: false,
    sq_discuss_protocol_modification: false,
    sq_discuss_lab: false,
    sq_discuss_special_proc: false,
    sq_discuss_data_entry: false,
    sq_discuss_storage: false,
    sq_discuss_ip_benefit: false,
    sq_discuss_publication_policy: false,
    sq_discuss_personnel: false,
    sq_discuss_training: false,
    sq_discuss_irb_time: false,
    sq_discuss_contract_time: false,
    sq_discuss_comment: '',
    sq_over_sponsor_responsibilities: false,
    sq_over_monitoring_plan: false,
    sq_over_data_management: false,
    sq_over_timelines: false,
    sq_over_key_dates: false,
    sq_over_other_info: false,
    sq_over_comment: '',
    sq_after_icf: false,
    sq_after_irb_sub: false,
    sq_after_budget: false,
    sq_after_cta: false,
    sq_after_document_track: false,
    sq_after_initiation_meeting: false,
    id: '',
    site_id: '',
    study_id: ''
  };
  const [sqChecklistFormData, setSqChecklistFormData] = React.useState<any>({
    site_visit_date: '',
    site_personnel_present: '',
    site_speciality: '',
    site_experience_trials: '',
    site_trials_completed: 0,
    site_trials_ongoing: 0,
    site_competitive_trials_on: true,
    site_positive_attributes: '',
    site_negative_attributes: '',
    site_requalification_visit: '',
    site_qualification_past_year: '',
    site_qualification_waived: '',
    site_not_suitable: '',
    site_smo_recommended: '',
    site_debarred: '',
    site_debarred_comment: '',
    site_483: '',
    site_483_comment: '',
    site_qualification_comments: '',
    created_by: user,
    site_id: selectedSite,
    study_id: studyId,
    updated_by: user
  });

  const [expanded, setExpanded] = React.useState<string | false>('panel1');

  const handleChange = (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
    if (isNavigateToPannel) {
      setExpanded(isExpanded ? panel : false);
    } else {
      setOpenAlertPopup(true);
      setCurrentPannel(panel);
    }
  };

  useEffect(() => {
    if (siteStudyPersonnelQueryData) {
      setSitestudySiteInfo(siteStudyPersonnelQueryData);
      setSiteInfoData(siteStudyPersonnelQueryData?.site);
      setTeamMbers(siteStudyPersonnelQueryData?.personnel);
      setSqChecklistFormData({ ...sqChecklistFormData, study_id: siteStudyPersonnelQueryData?.study.study_id });
      setUpdatedChecklist({
        ...updatedChecklist,
        study_id: siteStudyPersonnelQueryData?.study.study_id,
        site_id: selectedSite
      });
    }
    if (siteTsdaStudyPersonnelQueryData) {
      setSitestudySiteInfo(siteTsdaStudyPersonnelQueryData);
      setSiteInfoData(siteTsdaStudyPersonnelQueryData?.site);
      setTeamMbers(siteTsdaStudyPersonnelQueryData?.personnel);
      setSqChecklistFormData({ ...sqChecklistFormData, study_id: siteTsdaStudyPersonnelQueryData?.study.study_id });
      setUpdatedChecklist({
        ...updatedChecklist,
        study_id: siteTsdaStudyPersonnelQueryData?.study.study_id,
        site_id: selectedSite
      });
    }
  }, [siteStudyPersonnelQueryData, siteTsdaStudyPersonnelQueryData]);

  const getData = async () => {
    try {
      setIsLoading(true);
      await getSiteStudyPersonnelQueryData({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: currentAppName,
        site_users: true,
        strictly_site_users: true
      });
      setIsLoading(false);
    } catch (error) {
      dispatchApp(setMessage({ msgDetails: 'Error while creating site personnel', severity: 'error' }));
    }
  };

  useEffect(() => {
    getMonitoringVisitList(studyId, selectedCountry, selectedSite, selectedAppSection);
  }, [studyId]);

  const getMonitoringVisitList = async (
    studyId: string | null,
    selectedCountry: string | null,
    selectedSite: string | null,
    currentApp: string
  ) => {
    const allMonitoringResponse: any = await getAllMonitoringVisits({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application_section: selectedAppSection,
      data: {}
    });
    if (allMonitoringResponse.data && allMonitoringResponse.data.selected_data.length > 0) {
      const sqCheckedInDate: any = allMonitoringResponse.data.selected_data.filter(
        (visit: any) => visit.visit_type === 'Site Qualification Visit' && visit?.id === selectedRowData?.id
      );
      if (sqCheckedInDate.length && sqCheckedInDate[0].actual_start_date) {
        setCheckedInStartDate(
          moment(`${sqCheckedInDate[0].actual_start_date.replace(' ', 'T')}Z`).format(
            userPreferedDateFormat.toUpperCase()
          )
        );
      } else {
        setCheckedInStartDate(null);
      }
    } else {
      setCheckedInStartDate(null);
    }
  };

  useEffect(() => {
    if (monitoringVisitIsLoading) {
      dispatch(showLoader());
    } else if (monitoringVisitIsSuccess || monitoringVisitIsError) {
      dispatch(hideLoader());
    }
  }, [monitoringVisitIsLoading, monitoringVisitIsSuccess, monitoringVisitIsError]);

  const getAllProperty = <T, K extends keyof T>(obj: T, ...keys: K[]): object => {
    const newObj: any = {};
    keys.forEach(key => {
      newObj[key] = obj[key];
    });
    return newObj;
  };

  const [updatedChecklist, setUpdatedChecklist] = useState({
    updated_by: user,
    site_id: selectedSite,
    study_id: studyId
  });

  const handleCheck = (e: any) => {
    const data = e.target.value;
    const formattedVal = typeof data === 'string' ? formatInput(data) : data;
    setSqChecklistPILFormData({ ...sqChecklistPILFormData, [e.target.name]: formattedVal });
    setConfirmExitValue(dispatch, true);
  };
  const initialValidatoinObjectSQChecklist = {
    site_visit_date: false,
    site_experience_trials: false,
    site_competitive_trials_on: false,
    site_positive_attributes: false,
    site_negative_attributes: false,
    site_requalification_visit: false,
    site_qualification_past_year: false,
    site_qualification_waived: false,
    site_not_suitable: false,
    site_smo_recommended: false,
    site_debarred: false,
    site_483: false
  };
  const [validationObjsqChecklistFormData, setValidationObjsqChecklistFormData] = useState<any>(
    initialValidatoinObjectSQChecklist
  );

  const isValidsiteInfoDatasqChecklistFormData = () => {
    const newValidObj: any = { ...validationObjsqChecklistFormData };
    const validationArr: any = [];
    for (const key of Object.keys(validationObjsqChecklistFormData)) {
      if (sqChecklistFormData[key] === '' || sqChecklistFormData[key] === null) {
        newValidObj[key] = true;
        validationArr.push(false);
      }
    }
    setValidationObjsqChecklistFormData(newValidObj);
    if (validationArr.includes(false)) {
      return false;
    } else {
      return true;
    }
  };

  const handleSQCheckListSave = async (sqChecklistFormData: any) => {
    if (checkedInStartDate) {
      sqChecklistFormData.site_visit_date = moment(checkedInStartDate).format(SERVER_DATE_FORMAT);
    } else {
      sqChecklistFormData.site_visit_date = moment(sqChecklistFormData.site_visit_date).format(SERVER_DATE_FORMAT);
    }
    if (isValidsiteInfoDatasqChecklistFormData()) {
      const changedDate: any = new Date(sqChecklistFormData.site_visit_date);
      const validateDate: any =
        Object.prototype.toString.call(changedDate) === '[object Date]' && !isNaN(changedDate.getTime());
      if (
        validateDate &&
        sqChecklistFormData.site_positive_attributes &&
        sqChecklistFormData.site_negative_attributes
      ) {
        try {
          if (!updateKey) {
            setIsLoading(true);
            await createSqChecklist({
              site_id: selectedSite,
              study_id: studyId,
              data: sqChecklistFormData,
              country: selectedCountry,
              application: currentAppName
            });

            dispatchApp(setMessage({ msgDetails: sqcDataUpdateSuccessMsg, severity: 'success' }));
            setIsPublish(true);
            setConfirmExitValue(dispatch, false);
            setIsLoading(false);
            getChecklistDetails();
          } else {
            setIsLoading(true);
            await updateSqChecklist({
              site_id: selectedSite,
              study_id: studyId,
              data: updatedChecklist,
              country: selectedCountry,
              application: currentAppName
            });
            dispatchApp(setMessage({ msgDetails: sqcDataUpdateSuccessMsg, severity: 'success' }));
            setIsPublish(true);
            setConfirmExitValue(dispatch, false);
            setIsLoading(false);

            getChecklistDetails();
          }
          setIsChange(false);
        } catch (e: any) {
          dispatchApp(setMessage({ msgDetails: 'Error occurred while saving the data', severity: 'error' }));
          setIsLoading(false);
        }
      }
    }
  };

  const getPriorToVisit = () => {
    const sqChecklistPriorTovisit: ISQChecklistPriorToVisit = getAllProperty(
      sqChecklistPILFormData as ISQChecklistDetails,
      'sq_visit_date',
      'sq_reg_meeting_mil_track',
      'sq_reg_meeting_mil_track_comm',
      'sq_protocol_review_mil_track',
      'sq_protocol_review_mil_track_comm',
      'sq_contract_tim_mil_track',
      'sq_contract_tim_mil_track_comm',
      'sq_contract_review_name',
      'sq_contract_review_name_comm'
    ) as ISQChecklistPriorToVisit;
    return sqChecklistPriorTovisit;
  };

  const getDuringSiteQualificationData = () => {
    const sqChecklistDuringSiteQulification: ISQChecklistDuringSiteQualification = getAllProperty(
      sqChecklistPILFormData as ISQChecklistDetails,
      'sq_exam_room',
      'sq_lab_area',
      'sq_special_testing',
      'sq_pharmacy',
      'sq_hospital_unit',
      'sq_work_area',
      'sq_storage_area_ip',
      'sq_storage_area_supplies',
      'sq_sponsor_tour_comm',
      'sq_discuss_protocol_rev',
      'sq_discuss_protocol_modification',
      'sq_discuss_lab',
      'sq_discuss_special_proc',
      'sq_discuss_data_entry',
      'sq_discuss_storage',
      'sq_discuss_ip_benefit',
      'sq_discuss_publication_policy',
      'sq_discuss_personnel',
      'sq_discuss_training',
      'sq_discuss_irb_time',
      'sq_discuss_contract_time',
      'sq_discuss_comment',
      'sq_over_sponsor_responsibilities',
      'sq_over_monitoring_plan',
      'sq_over_data_management',
      'sq_over_timelines',
      'sq_over_key_dates',
      'sq_over_other_info',
      'sq_over_comment'
    ) as ISQChecklistDuringSiteQualification;
    return sqChecklistDuringSiteQulification;
  };

  const getAfterSiteQualificationData = () => {
    const sqChecklistAfterSiteQulification: ISQChecklistAfterSiteQualification = getAllProperty(
      sqChecklistPILFormData as ISQChecklistDetails,
      'sq_after_icf',
      'sq_after_irb_sub',
      'sq_after_budget',
      'sq_after_cta',
      'sq_after_document_track',
      'sq_after_initiation_meeting'
    ) as ISQChecklistAfterSiteQualification;
    return sqChecklistAfterSiteQulification;
  };

  const priorToVisitUpdate = async () => {
    const sqChecklistPost: SqChecklistPostPriorDetails = {
      sq_checklist: {
        prior_to_the_visit: getPriorToVisit()
      },
      created_by: user,
      monitoring_visit_id: selectedRowData.id,
      is_submit: false,
      updated_by: user
    };
    postData(sqChecklistPost, 'prior to visit');
  };

  const durationSiteVisitUpdate = async () => {
    const sqChecklistPILPost: SqChecklistPostDuringSiteQualification = {
      sq_checklist: {
        during_the_sitequalification_visit: getDuringSiteQualificationData()
      },
      created_by: user,
      monitoring_visit_id: selectedRowData.id,
      updated_by: user
    };
    postData(sqChecklistPILPost, 'prior to visit');
  };

  const afterSiteVisitUpdate = async () => {
    const sqChecklistPILPost: SqChecklistPostAfterSiteQualification = {
      sq_checklist: {
        after_the_sitequalification_visit: getAfterSiteQualificationData()
      },
      created_by: user,
      monitoring_visit_id: selectedRowData.id,
      updated_by: user
    };
    postData(sqChecklistPILPost, 'prior to visit');
  };

  const postData = async (reqObj: any, sectionName: string) => {
    try {
      dispatch(showLoader());
      if (newPilupdateKey) {
        await updateSqChecklistPIL({
          site_id: selectedSite,
          study_id: studyId,
          data: reqObj,
          country: selectedCountry,
          application: currentAppName
        });
      } else {
        await createSqChecklistPIL({
          site_id: selectedSite,
          study_id: studyId,
          data: reqObj,
          country: selectedCountry,
          application: currentAppName
        });
      }
      dispatchApp(setMessage({ msgDetails: sqcDataUpdateSuccessMsg, severity: 'success' }));
      setnPilupdateKey(true);
      getSqChecklistPILQueryData({
        monitoring_visit_id: selectedRowData.id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: currentAppName
      });
      setConfirmExitValue(dispatch, false);
      dispatch(hideLoader());
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: 'Error occurred while saving the data', severity: 'error' }));
    }
  };

  useEffect(() => {
    if (getsqChecklistIsSuccess) {
      (async () => {
        const tempSQVisitDate = await getMonitoringEventData();
        const updateChecklistWithVisitDate =
          sqChecklistData.site_visit_date !== '' || sqChecklistData.site_visit_date !== null
            ? sqChecklistData
            : {
                ...sqChecklistData,
                site_visit_date: tempSQVisitDate
                  ? moment(new Date(`${tempSQVisitDate}Z`)).format(userPreferedDateFormat.toUpperCase())
                  : ''
              };
        setSqChecklistFormData(updateChecklistWithVisitDate);
        setUpdatedChecklist(sqChecklistData);
        setUpdateKey(true);
        setIsLoading(false);
      })();
    }
  }, [getsqChecklistIsSuccess]);

  useEffect(() => {
    if (getsqChecklistIsError) {
      (async () => {
        const tempSQVisitDate = await getMonitoringEventData();
        setIsLoading(false);
        setSqChecklistFormData({
          ...mockEmptySQCheckListData,
          site_visit_date: tempSQVisitDate
            ? moment(new Date(`${tempSQVisitDate}Z`)).format(userPreferedDateFormat.toUpperCase())
            : ''
        });
        updateUserAccess(getsqChecklistError, dispatch);
      })();
    }
  }, [getsqChecklistIsError]);

  useEffect(() => {
    if (getsqChecklistPILIsSuccess && sqChecklistPILData) {
      setSqChecklistPILFormData({ ...sqChecklistPILData?.sq_checklist_data });
      const document: any = sqChecklistPILData?.documents.map((item: any, i: any) => {
        if (item) {
          return { ...item, id: i + 1 };
        }
      });
      setUploadDocuments(document);
      setnPilupdateKey(true);
      setIsLoading(false);
    }
  }, [getsqChecklistPILIsSuccess, sqChecklistPILData]);

  useEffect(() => {
    if (getSqChecklistPILLoading) {
      dispatchApp(showLoader());
    } else {
      dispatchApp(hideLoader());
    }
  }, [getSqChecklistPILLoading]);
  useEffect(() => {
    if (getSqChecklistPILIsError) {
      setIsLoading(false);
      setSqChecklistPILFormData(mockEmptySQCheckPILData);
    }
  }, [getSqChecklistPILIsError]);

  useEffect(() => {
    if (archLevel === 'site') {
      switch (fromNavigationPathName) {
        case 'Summary-sqChecklist-priorvisit':
          setExpanded('panel3');
          break;
        case 'Summary-sqChecklist-supportdoc':
          setExpanded('panel4');
          break;
        case 'Summary-sqChecklist-dsqvisit':
          setExpanded('panel5');
          break;
        case 'Summary-sqChecklist-asqvisit':
          setExpanded('panel6');
          break;
        default:
          setExpanded('panel3');
      }
    }
    setValidationObjsqChecklistFormData(initialValidatoinObjectSQChecklist);
    getData();
    getChecklistDetails();
  }, [selectedSite]);

  const getChecklistDetails = () => {
    if (archLevel == 'sponsor') {
      getChecklistData({
        monitoring_visit_id: selectedRowData.id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: currentAppName
      });
    } else if (checkPermission('view_sq_checklist_pil') && archLevel == 'site') {
      getSqChecklistPILQueryData({
        monitoring_visit_id: selectedRowData.id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: currentAppName
      });
      !fromNavigationPathName && setExpanded('panel3');
    }
  };

  const confirmexitpopupval: any = useSelector((state: AppState) => state.confirmexitpopupval);
  const handleNextbtn = (e: any) => {
    const popupShowed = localStorage.getItem('popupShowed');
    if (popupShowed == 'true' && confirmexitpopupval.confirmexitpopupval == true) {
      setConfirmExitPopupVal(dispatch, false);
      setConfirmExitPopupVal(dispatch, true);
    }
    setTabVal(tabVal + 1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClose = () => {
    setOpenAlertPopup(false);
  };

  const handleYes = () => {
    setOpenAlertPopup(false);
    setIsNavigateToPannel(true);
    setExpanded(currentPannel);
  };
  const handlePublishSQCL = async () => {
    let version: any = 0;
    if (isUpdatePublish) {
      version = Math.floor(sqChecklistData?.sq_checklist_publish_version + 1);
    } else {
      version = 1;
    }
    if (publishChecklistPermission) {
      try {
        dispatch(showLoader());
        await publishSQChecklistEtmf({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          monitoring_visit_id: selectedRowData?.id,
          publish_doc_version: parseFloat(version).toFixed(1),
          is_published: true,
          update: isUpdatePublish,
          application: currentAppName,
          application_section: selectedAppSection
        });
        dispatch(hideLoader());
        getChecklistDetails();
      } catch (error: any) {
        dispatch(hideLoader());
        if (error && error?.response?.status === 403) {
          dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
        } else if (error && error.response?.status === 401) {
          dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
        } else {
          dispatch(setMessage({ msgDetails: 'Error while publishing', severity: 'error' }));
        }
      }
    }
    setConfirmExitValue(dispatch, false);
  };

  useEffect(() => {
    if (publishSQChecklistSuccess) {
      dispatchApp(
        setMessage({
          msgDetails: ` ${selectedRowData.visit_name} successfully published to ETMF`,
          severity: 'success'
        })
      );
      setIsPublish(false);
      setPrintEnable(true);
    }
  }, [publishSQChecklistSuccess]);

  const printSQCL = async () => {
    try {
      dispatch(showLoader());
      const options = {
        sq_visit_id: selectedRowData?.id,
        template_name: 'site_qualification_visit_checklist',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          time_zone_id: UI_TIME_ZONE,
          country: selectedCountry,
          appName: currentAppName
        }
      };
      printPdfWithViewer('get_sqconfirmationletter_pdf_file', options, 'application/pdf');
      setTimeout(() => {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
    setConfirmExitValue(dispatch, false);
  };
  const handelBackButton = () => {
    dispatch(setChckListCMPArr('sqchecklistview'));
  };
  useEffect(() => {
    return () => {
      handelBackButton();
    };
  }, []);

  return (
    <>
      <Grid container mb={2} mt={-1}>
        <Grid item md={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button
            onClick={handelBackButton}
            key={staticData.sqChecklistView.back_button}
            startIcon={<DynamicIcon name={staticData.sqChecklistView.icon} />}
          >
            {staticData.sqChecklistView.back_button_name}
          </Button>

          <Stack direction="row" spacing={1.5}>
            {archLevel === 'sponsor' ? (
              <Button
                variant="contained"
                sx={{ alignSelf: 'center', textTransform: 'none' }}
                disabled={
                  !publishChecklistPermission ||
                  (!isPublish
                    ? sqChecklistData?.is_published === null || sqChecklistData?.is_published === undefined
                      ? !isPublish
                      : sqChecklistData?.is_published
                    : !isPublish) ||
                  !checkedInStartDate
                }
                onClick={() => handlePublishSQCL()}
              >
                PUBLISH TO eTMF
              </Button>
            ) : (
              <Button variant="contained" style={{ textTransform: 'none' }} sx={{ alignSelf: 'center' }} disabled>
                PUBLISH TO eISF
              </Button>
            )}
            <IconButton
              aria-label="Print"
              color="primary"
              sx={{ alignSelf: 'center' }}
              onClick={() => printSQCL()}
              disabled={sqChecklistData?.is_published === true ? false : !printEnable}
            >
              <LocalPrintshopIcon />
            </IconButton>
          </Stack>
        </Grid>
      </Grid>
      <div className="pi-accordion lastAccordionSetting">
        {isLoading && <ProgressBar />}
        <Loader />
        <Accordion
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
          hidden={!checkPermission('view_sq_checklist')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <Typography>Site Information</Typography>
          </AccordionSummary>
          {Object.keys(sitestudySiteInfo).length !== 0 && siteInfoData && (
            <SiteInformation
              siteStudyPersonnelQueryData={siteStudyPersonnelQueryData}
              siteTsdaStudyPersonnelQueryData={siteTsdaStudyPersonnelQueryData}
              siteStudyPersonnelQueryDataIsSuccess={siteStudyPersonnelQueryDataIsSuccess}
              siteTsdaStudyPersonnelQueryDataIsSuccess={siteTsdaStudyPersonnelQueryDataIsSuccess}
              siteStudyPersonnelQueryDataLoading={siteStudyPersonnelQueryDataLoading}
              siteTsdaStudyPersonnelQueryDataLoading={siteTsdaStudyPersonnelQueryDataLoading}
              setIsNavigateToPannel={setIsNavigateToPannel}
              ItIsSQ
            />
          )}
        </Accordion>

        <Accordion
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
          hidden={!checkPermission('view_sq_checklist')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>SQ Checklist</Typography>
          </AccordionSummary>
          <SQChecklist
            handleSQCheckListSave={handleSQCheckListSave}
            sqChecklistFormData={sqChecklistFormData}
            setSqChecklistFormData={setSqChecklistFormData}
            teamMembers={teamMembers}
            setUpdatedChecklist={setUpdatedChecklist}
            updatedChecklist={updatedChecklist}
            validationObjsqChecklistFormData={validationObjsqChecklistFormData}
            setValidationObjsqChecklistFormData={setValidationObjsqChecklistFormData}
            selectedSite={selectedSite}
            studyId={studyId}
            checkedInStartDate={checkedInStartDate}
            setIsNavigateToPannel={setIsNavigateToPannel}
            isChange={isChange}
            setIsChange={setIsChange}
          />
        </Accordion>
        <Accordion
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
          hidden={!checkPermission('view_sq_checklist_pil')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Prior to the visit</Typography>
          </AccordionSummary>
          <PriorToVisit
            priorToVisitUpdate={priorToVisitUpdate}
            sqChecklistPILFormData={sqChecklistPILFormData}
            setSqChecklistPILFormData={setSqChecklistPILFormData}
            selectedSite={selectedSite}
            studyId={studyId}
            newPilupdateKey={newPilupdateKey}
            handleCheck={handleCheck}
            setIsNavigateToPannel={setIsNavigateToPannel}
            checkedInStartDate={checkedInStartDate}
          />
        </Accordion>
        <Accordion
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
          hidden={!checkPermission('view_sq_checklist_pil')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Supporting Documentation (If applicable)</Typography>
          </AccordionSummary>
          <SupportDocuments
            uploadDocuments={uploadDocuments}
            setUploadDocuments={setUploadDocuments}
            getSQCheListPILData={getSqChecklistPILQueryData}
            sqChecklistPILFormData={sqChecklistPILFormData}
            setSqChecklistPILFormData={setSqChecklistPILFormData}
            selectedSite={selectedSite}
            studyId={studyId}
            selectedCountry={selectedCountry}
            newPilupdateKey={newPilupdateKey}
            handleCheck={handleCheck}
            setIsNavigateToPannel={setIsNavigateToPannel}
            checkedInStartDate={checkedInStartDate}
            selectedRowData={selectedRowData}
          />
        </Accordion>
        <Accordion
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
          hidden={!checkPermission('view_sq_checklist_pil')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>During the Site Qualification Visit</Typography>
          </AccordionSummary>
          <DuringSiteQulificationVisit
            durationSiteVisitUpdate={durationSiteVisitUpdate}
            sqChecklistPILFormData={sqChecklistPILFormData}
            setSqChecklistPILFormData={setSqChecklistPILFormData}
            selectedSite={selectedSite}
            studyId={studyId}
            newPilupdateKey={newPilupdateKey}
            handleCheck={handleCheck}
            setIsNavigateToPannel={setIsNavigateToPannel}
            checkedInStartDate={checkedInStartDate}
          />
        </Accordion>

        <Accordion
          expanded={expanded === 'panel6'}
          onChange={handleChange('panel6')}
          hidden={!checkPermission('view_sq_checklist_pil')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>After the Site Qualification visit</Typography>
          </AccordionSummary>
          <AfterSiteQualificationVisit
            AfterSiteVisitUpdate={afterSiteVisitUpdate}
            sqChecklistPILFormData={sqChecklistPILFormData}
            setSqChecklistPILFormData={setSqChecklistPILFormData}
            selectedSite={selectedSite}
            studyId={studyId}
            newPilupdateKey={newPilupdateKey}
            handleCheck={handleCheck}
            setIsNavigateToPannel={setIsNavigateToPannel}
            checkedInStartDate={checkedInStartDate}
          />
        </Accordion>
        <PopupComponent
          open={openAlertPopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
        >
          <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} className="grey-btn">
              Close
            </Button>
            <Button onClick={handleYes} autoFocus>
              Ok
            </Button>
          </DialogActions>
        </PopupComponent>
        {currentTabinfo[0]?.NextButton && (
          <Grid container spacing={2} className="bottom-navigation">
            <Grid item md={12} display="flex" justifyContent="flex-end">
              <Stack spacing={2} direction="row">
                <Button onClick={handleNextbtn} variant="contained">
                  NEXT
                </Button>
              </Stack>
            </Grid>
          </Grid>
        )}
      </div>
    </>
  );
};

export default SQChecklistPage;
